export default __webpack_public_path__ + "static/media/stripe-up-mobile.689dc2ed.svg";